export function rangeArray(start: number, end: number) {
  return Array(end - start + 1)
    .fill(0)
    .map((_, i: number) => start + i);
}
